<app-student-module ModuleName='Other Factors' [PrintOptions]="printOptions">
  <sortable-table (delCall)="del($event)" (saveCall)="save($event)" [data]="otherfactors" [headers]="headers"
                  [showAdd]="true" [showDelete]="true" [showEdit]="true"
                  defaultSort="date"></sortable-table>
</app-student-module>
